<template>
  <div class="card h-100  text-center">
      <header class="card-header text-uppercase text-info">
        <h4><font-awesome-icon icon="dice"/> Playoff</h4>
      </header>
      <section class="card-body ">
        <p>
          We narrowed down to <span class="highlightedNumber">{{ numPlayoff }}</span> colors.
        </p>
        <p>
          Would you like to have a playoff?
        </p>
      </section>
      <footer class="card-footer">
          <div class="row">
              <div class="col-12">
                  <button class="btn btn-outline-warning" type="button" @click="toResults">
                      <font-awesome-icon icon="check-square"/>
                      <span class="ml-1"><span class="d-none d-md-inline">No I'm </span>Done</span>
                  </button>
                  <button class="btn btn-outline-success ml-2" @click="doPlayoff">
                      <font-awesome-icon icon="caret-square-right"/>
                      <span class="ml-1"><span class="d-none d-md-inline">Lets </span>Playoff</span>
                  </button>
              </div>
          </div>
      </footer>
  </div>
</template>

<script>
  export default {
    name: 'PlayoffModal',
    props: ['numPlayoff'],
    methods: {
      toResults() {
        this.$emit('go-to-results');
      },
      doPlayoff() {
        this.$emit('do-playoff');
      },
    },
  };
</script>

<style scoped>
  .highlightedNumber {
    font-weight: bold;
    font-size: 1.1rem;
  }
</style>
